import type { FC } from 'react';
import { Location } from 'iconsax-react';

interface EntityDisplayProps {
  main?: string | null;
  sub?: string | null;
  icon?: boolean;
}

const EntityDisplay: FC<EntityDisplayProps> = ({ main, sub, icon }) => {
  const isMainValid = !!main && main.trim() !== '';

  if (!isMainValid) {
    return <span className='text-sm text-gray-500 px-2 py-1'>—</span>;
  }

  return (
    <div className='flex flex-col px-2 py-1 min-w-0'>
      <span className='text-sm font-medium text-gray-800 truncate'>{main}</span>
      {sub && (
        <span className='text-gray-500 flex items-center gap-1'>
          {icon && (
            <Location
              size='16'
              className='text-gray-600'
              variant='TwoTone'
            />
          )}
          {sub}
        </span>
      )}
    </div>
  );
};

export default EntityDisplay;
